<template>
    <div
        ref="obsah"
        class="overflow-y-auto"
    >
        <NuxtLink
            v-for="(item, index) in contents"
            :id="`obsah_${item.kniha}.${item.kod}`"
            :key="item.kod"
            :to="localePath(`/texty/${item.kniha}/${item.kod}`)"
            :class="{
                'pointer-events-none': active === `${item.kniha}.${item.kod}`,
            }"
            @click="store.mobileLeftPanelOpen = false"
        >
            <div
                class="flex gap-2 hover:text-hover-link"
                :class="{
                    'font-probold text-hover-link underline':
                        active === `${item.kniha}.${item.kod}`,
                    'font-probold': item.style === 'uap02',
                    'mt-4': index > 0 && item.style === 'uap02',
                    'my-2 font-promedium': item.style === 'uap03',
                }"
            >
                <span class="w-1/5 shrink-0">{{ item.kod }}</span>
                <span class="">{{ item.nazev }}</span>
            </div>
        </NuxtLink>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()
const localePath = useLocalePath()
const props = defineProps<{
    contents: BookTreeItem[]
    active: string
}>()

const obsah = ref<HTMLElement | null>(null)

onMounted(async () => {
    await nextTick(() => {
        setTimeout(() => {
            const activeElement = document.getElementById(
                `obsah_${props.active}`
            )
            if (activeElement) {
                activeElement.scrollIntoView({
                    block: "nearest",
                })
                //activeElement.scrollIntoView()
            }
        }, 300)
    })
})
/* obsah.value?.scrollTo({
    top: activeElement.offsetTop - 300,
    behavior: 'smooth',
}) */
</script>

<style scoped></style>
